import React from 'react'
import cx from 'classnames'

import { MobileWarning } from 'common/core/components/MobileWarning/MobileWarning'
import Title from 'common/core/components/Title/Title'

import cm from './Page.module.css'

interface Props {
  title?: string | React.ReactElement
  footer?: string | React.ReactElement
  className?: string
  contentClassName?: string
  contentStyle?: Record<string, string>
  noContentPadding?: boolean
  hideMobileWarning?: boolean
  contentBeforePage?: string | null
  children: React.ReactNode
  showTitle?: boolean
}

const Page = ({
  title,
  footer,
  className = '',
  contentClassName,
  noContentPadding,
  contentStyle = {},
  hideMobileWarning,
  contentBeforePage = null,
  children,
  showTitle = true,
}: Props) => (
  <div className={cx(cm.wrapper, className)}>
    {showTitle && <>{title && React.isValidElement(title) ? title : <Title>{title}</Title>}</>}
    {contentBeforePage && React.isValidElement(contentBeforePage) && contentBeforePage}
    <div
      id="appContent"
      className={cx(cm.content, contentClassName, 'page-content', {
        [cm.noPadding]: noContentPadding,
      })}
      style={contentStyle}
    >
      {!hideMobileWarning && <MobileWarning />}
      {children}
    </div>
    {footer && React.isValidElement(footer) && footer}
  </div>
)

export default Page
